import Image from "next/image"

import closeIcon from "@/public/icons/close.svg"
import Style from "@/components/core/SlideDrawer/index.module.scss"

import { useEffect } from "react"
import { addAnalyticsCloseSliderProductOnDisplay } from "@/components/ProductDetail/v3/ProductDetailView/ProductOnDisplay/analytics"

const SlideDrawer = props => {
  const { isOpen = false, title = "", subTitle = "", children, onClose } = props
  useEffect(() => {
    if (isOpen) {
      document.querySelector("body").classList.add("drawer-open")
    } else {
      const drawerOpen = document.getElementsByClassName("drawer-open")
      if (drawerOpen.length > 0) {
        addAnalyticsCloseSliderProductOnDisplay()
      }
      document.querySelector("body").classList.remove("drawer-open")
    }
  }, [isOpen])

  return (
    <>
      {isOpen ? (
        <div className={`${Style.SlideDrawerBackdrop} `} onClick={onClose} />
      ) : null}
      <div className={`${Style.SlideDrawer} ${isOpen ? Style.Open : ""}`}>
        <div className="header">
          <div className="close-btn">
            <Image
              src={closeIcon}
              height={17}
              width={17}
              alt="Close"
              onClick={() => onClose(false)}
            />
          </div>
          <div className="title">{title}</div>
          <div className="sub-title">{subTitle}</div>
        </div>
        {children}
      </div>
    </>
  )
}

export default SlideDrawer
